import { motion, AnimatePresence } from "framer-motion";
import { ReactNode } from "react";
import { useLocation } from "react-router-dom";

interface PageTransitionProps {
  children: ReactNode;
}

export default function PageTransition({ children }: PageTransitionProps) {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={location.pathname}
        initial={{ opacity: 0, y: 30, filter: 'blur(5px)', willChange: 'transform, opacity, filter' }}
        animate={{
          opacity: 1,
          y: 0,
          filter: 'blur(0px)',
          transitionEnd: {
            filter: "none",
            transform: "none",
            willChange: "auto"
          }
        }}
        exit={{ opacity: 0, y: -30, filter: 'blur(5px)', willChange: 'transform, opacity, filter' }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        className="relative w-full"
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
}